import { useSyncExternalStore } from 'react';

/**
 * Whether a CSS media query matches, kept live. Where matchMedia is missing
 * (old engines, tests) it answers `fallback`.
 */
export function useMatchMedia(query: string, fallback = false): boolean {
  return useSyncExternalStore(
    (onChange) => {
      if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return () => undefined;
      const mql = window.matchMedia(query);
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    },
    () => (typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(query).matches : fallback),
    () => fallback,
  );
}

/** Tailwind's `lg` breakpoint (1024px): the desktop shell with the sidebar rail. */
export const DESKTOP_QUERY = '(min-width: 1024px)';

/** Tailwind's `xl` breakpoint (1280px): wide enough for the rail to keep its labels (DS04). */
export const WIDE_QUERY = '(min-width: 1280px)';
